import { NewPeriod } from '@app/models/period';
import api from '@services/api';
import { EventRequest, EventResponse } from '../models/event';

import { PaginationResponse } from '../models/pagination';
import { ProcessRequest } from '../models/sharingPMO';

/**
 * <p>
 * API endpoints that cover all resource event related CRUD calls
 */
export const eventApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // POST
    UploadEventFile: builder.mutation<PaginationResponse<NewPeriod>, ProcessRequest>({
      query: (input: ProcessRequest) => ({
        url: encodeURI(`/school/event/upload?periodDate=${input.periodDate}`),
        method: 'POST',
        body: input.body,
      }),
      invalidatesTags: ['EventsResponse', 'Periods'],
    }),
    // GET
    EventsResponse: builder.query<PaginationResponse<EventResponse>, EventRequest>({
      query: (request) => ({
        url: encodeURI(
          `/school/event/search?${
            request.searchTerm ? `searchTerm=${request.searchTerm}&` : ''
          }periodDate=${request.periodDate}&page=${request.page}&size=${request.size}`,
        ),
        method: 'GET',
      }),
      providesTags: ['EventsResponse'],
    }),
  }),
});

export const { useUploadEventFileMutation, useEventsResponseQuery } = eventApi;
